import { ArrowRight, Shell } from 'lucide-react';
import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import OfferIcon from '../components/OfferIcon';

const cards = [
  { type: 'book' as const, name: 'Premier Regard', pitch: 'Découvrir le potentiel de votre manuscrit.', price: '50 €' },
  { type: 'wave' as const, name: 'Immersion', pitch: 'Prendre du recul sur votre manuscrit.', price: 'Sur devis' },
  { type: 'boat' as const, name: 'Grand Large', pitch: 'Être accompagné pour aller plus loin.', price: 'Sur devis' },
  { type: 'feather' as const, name: 'Ligne Claire', pitch: 'Offrir à votre texte une lecture plus fluide.', price: 'Sur devis' },
];

export default function Tarifs() {
  return (
    <>
      <section className="tarifs-hero">
        <div className="container-wide tarifs-hero-inner">
          <div className="tarifs-hero-copy">
            <span className="eyebrow">Mes tarifs</span><div className="mini-wave" />
            <h1>À chaque histoire,<br /><em>son accompagnement.</em></h1>
            <p>Des prestations adaptées à votre manuscrit,<br />à vos besoins et à vos envies.</p>
            <div className="shell-rule"><Shell size={28} /><span /></div>
          </div>
          <div className="tarifs-photo" />
        </div>
      </section>
      <section className="pricing-grid container-wide">
        {cards.map(c => (
          <article className="price-card" key={c.name}>
            <OfferIcon type={c.type} size={105} />
            <h2>{c.name}</h2><div className="mini-wave centered" />
            <p>{c.pitch}</p><strong>{c.price}</strong>
            <Link className="button button-clay" to="/prestations">En savoir plus <ArrowRight size={19} /></Link>
          </article>
        ))}
      </section>
      
      <section className="tarifs-seo container-wide">
        <div className="tarifs-seo-copy">
          <span className="eyebrow eyebrow-clay">
            Des tarifs adaptés à votre projet
          </span>

          <h2>Quel tarif pour la correction d'un manuscrit ?</h2>

          <p>
            Le tarif d'une correction de manuscrit ou de roman
            dépend de plusieurs éléments : la longueur du texte,
            le travail nécessaire et le type de prestation souhaité.
          </p>

          <p>
            Que vous recherchiez une relecture attentive,
            une analyse approfondie ou une correction
            orthographique et grammaticale, je vous propose
            un accompagnement adapté à votre projet.
          </p>

          <p>
            Pour la prestation Premier Regard, le tarif est fixé
            à 50 € pour les 40 premières pages et le prologue.
            Pour les autres prestations, un devis personnalisé
            vous est proposé après étude de votre demande.
          </p>
        </div>
      </section>

      <section className="unique-note container-wide"><Shell /><div><h3>Chaque manuscrit est unique.</h3><p>Pour les prestations sur devis, je vous propose un tarif personnalisé, adapté à la longueur de votre texte et à vos besoins.</p></div></section>
      <CtaBand />
    </>
  );
}
